/* eslint-disable */
const url: typeof URL = globalThis.URL;
const urlSearchParams: typeof URLSearchParams = globalThis.URLSearchParams;

if (!url || !urlSearchParams) {
    throw new Error("URL APIs are not available in the current environment.");
}

export {url as URL, urlSearchParams as URLSearchParams};
